/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, HFlow, Icon, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { PrioridadeRegulacaoEnum, StatusRegulacaoEnum } from 'graphql/types.generated'
import { useServerTime } from 'hooks/useServerTime'
import React from 'react'
import StatusSquare from 'view/atendimentos/detail/historico/components/StatusSquare'

import { StatusRegulacaoEnumMap } from '../../components/ListaRegulacaoTable'
import {
  regulacaoClassificacaoPrioridadeRecord,
  RegulacaoEnumTextMap,
  RegulacaoEvolucaoModel,
} from '../../model-regulacao'
import { formatDateHistoricoRegulacao } from '../../utils-regulacao'

interface HistoricoRegulacaoEvolucaoItemProps {
  item: RegulacaoEvolucaoModel
  showConnector: boolean
  showPrioridade: boolean
}

export function HistoricoRegulacaoEvolucaoItem(props: Readonly<HistoricoRegulacaoEvolucaoItemProps>) {
  const { item, showConnector, showPrioridade } = props

  const theme = useTheme()
  const { getServerTimeNow } = useServerTime()
  const { colorScale, icon, svgIcon } = StatusRegulacaoEnumMap[item.statusRegulacao]
  const styles = createStyles(theme, colorScale?.c40)
  const formattedDate = formatDateHistoricoRegulacao(item.dataEvolucao, getServerTimeNow())
  const { label, mainColor } = regulacaoClassificacaoPrioridadeRecord[item.prioridade]
  const isStatusSolicitada = item.statusRegulacao === StatusRegulacaoEnum.SOLICITADA

  return (
    <HFlow style={styles.root} hSpacing={0.5}>
      {icon ? (
        <Icon icon={icon} color={colorScale.c40} />
      ) : (
        React.cloneElement(svgIcon, {
          style: isStatusSolicitada
            ? { height: '1.3rem', width: '1.3rem', marginLeft: '1px' }
            : { height: '1.5rem', width: '1.5rem' },
        })
      )}

      {showConnector && <span css={styles.connector} />}
      <VFlow vSpacing={0}>
        <HFlow hSpacing={0.25}>
          <Heading level={4} style={!isStatusSolicitada ? styles.heading : {}}>
            {RegulacaoEnumTextMap[item.statusRegulacao]}
          </Heading>
          <Text style={styles.date}>| Atualizado {formattedDate}</Text>
        </HFlow>
        <HLabel title='Observações:' style={styles.observacao}>
          {item.observacao}
        </HLabel>
        {showPrioridade && item.prioridade !== PrioridadeRegulacaoEnum.NAO_INFORMADA && (
          <HFlow hSpacing={0.5}>
            <Heading level={5}>Classificação de prioridade pela regulação:</Heading>
            <StatusSquare color={mainColor} description={label} />
          </HFlow>
        )}
      </VFlow>
    </HFlow>
  )
}

const createStyles = (theme: Theme, color: string) => ({
  root: css`
    position: relative;
  `,
  heading: css`
    color: ${color};
  `,
  date: css`
    color: ${theme.pallete.gray.c40};
  `,
  connector: css`
    z-index: 1;
    height: calc(100% - 16px);
    position: absolute;
    top: 24px;
    left: 11px;
    border-left-width: 2px;
    border-left-style: solid;
    border-left-color: ${theme.pallete.gray.c80};
  `,
  observacao: css`
    word-break: break-word;
  `,
})
